// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class ReviewerModal extends JQueryView {
  constructor() {
    super('.modal-dialog');
  }

  @on({ event: 'click', selector: '#add-reviewer' })
  onClickAddReviewerTab() {
    $('#add-reviewer').addClass('active');
    $('#edit-reviewer').removeClass('active');
    $('#add-reviewer-button')
      .addClass('d-block')
      .removeClass('d-none');
    $('#edit-reviewer-button')
      .addClass('d-none')
      .removeClass('d-block');
  }

  @on({ event: 'click', selector: '#edit-reviewer' })
  onClickEditReviewerTab() {
    $('#edit-reviewer').addClass('active');
    $('#add-reviewer').removeClass('active');
    $('#edit-reviewer-button')
      .addClass('d-block')
      .removeClass('d-none');
    $('#add-reviewer-button')
      .addClass('d-none')
      .removeClass('d-block');
  }

  @on({ event: 'click', selector: '#back-button' })
  onClickBackButton() {
    $('#form-modal').modal('hide');
    $('#select-modal').modal('show');
  }
}
